import React from 'react';
import { useSelector } from 'react-redux';
import Unidentified from './variants/unidentified/unidentified';
import RegisteredTeacherRegistrationStage from './variants/registeredTeacherRegistrationStage/registeredTeacherRegistrationStage';
import StudentRegistrationStage from './variants/studentRegistrationStage/studentRegistrationStage';
import UnregisteredTeacherRegistrationStage from './variants/unregisteredTeacherRegistrationStage/unregisteredTeacherRegistrationStage';
import UnregisteredTeacherContestStage from './variants/unregisteredTeacherContestStage/unregisteredTeacherContestStage';
import RegisteredTeacherContestStage from './variants/registeredTeacherContestStage/registeredTeacherContestStage';
import StudentContestStage from './variants/studentContestStage/StudentContestStage';
import classes from './CompetitionStatus.module.css';

const COMPONENT_MAP = {
  unidentified: Unidentified,
  registeredTeacherRegistrationStage: RegisteredTeacherRegistrationStage,
  studentRegistrationStage: StudentRegistrationStage,
  unregisteredTeacherRegistrationStage: UnregisteredTeacherRegistrationStage,
  unregisteredStudentContestStage: StudentContestStage,
  registeredStudentContestStage: StudentContestStage,
  emergencyStudentContestStage: StudentContestStage,
  emergencyTeacherContestStage: RegisteredTeacherContestStage,
  unregisteredTeacherContestStage: UnregisteredTeacherContestStage,
  registeredTeacherContestStage: RegisteredTeacherContestStage,
};

const CompetitionStatus = ({ componentType, props }) => {

  const { school } = useSelector(state => state.auth);


  const Component = COMPONENT_MAP[componentType];

  if (!Component) {
    if (!school?.id) {
      return null;
    }
    return <div className={classes.frame} />;
  }

  return <Component {...props} />;
};

export default CompetitionStatus;

